import { apiGet, apiPost } from './client';
import type { OperationResult } from './types';

// ─────────────────────────────────────────────────────────────────────────────
// Per-user pinned agents (favorites). Backed by ai.UserAgentPin and
// /api/UserAgentPin/{Mine,Pin,Unpin}. Drives the ⭐ Pinned section at the
// top of the Agents list.
// ─────────────────────────────────────────────────────────────────────────────

export interface PinnedAgentRow {
  agentId: number;
  displayName?: string | null;
  canonicalName?: string | null;
  audience?: string | null;
  isActive?: boolean | null;
  patientApp?: boolean | null;
  merchantApp?: boolean | null;
  pinnedAtUtc: string;
  displayOrder: number;
}

export async function getMyPinnedAgents(): Promise<PinnedAgentRow[]> {
  const wrapped = await apiGet<OperationResult<PinnedAgentRow[]>>('/api/UserAgentPin/Mine');
  if (!wrapped.isSuccess) throw new Error(wrapped.message || 'Failed to load pinned agents');
  return wrapped.data ?? [];
}

/** Idempotent — pin twice = one row. Server handles the dedupe. */
export async function pinAgent(agentId: number): Promise<void> {
  const wrapped = await apiPost<OperationResult<unknown>>('/api/UserAgentPin/Pin', { agentId });
  if (!wrapped.isSuccess) throw new Error(wrapped.message || 'Failed to pin agent');
}

export async function unpinAgent(agentId: number): Promise<void> {
  const wrapped = await apiPost<OperationResult<unknown>>('/api/UserAgentPin/Unpin', { agentId });
  if (!wrapped.isSuccess) throw new Error(wrapped.message || 'Failed to unpin agent');
}
